import cx from 'classnames'
import * as React from 'react'

import { BackgroundColorVariables, SpacingProps } from '../shared-types'
import Spacer from '../spacer'
import styles from './content-box.module.scss'

export type Props = {
  children?: React.ReactNode | string
  footerButtons?: React.ReactNode
  className?: string
  backgroundColor?: BackgroundColorVariables
} & SpacingProps

export default function ContentBox(props: Props) {
  const {
    children,
    footerButtons,
    className,
    backgroundColor = 'primary',
    ...otherProps
  } = props
  const classNames = cx([[styles.root], [styles[backgroundColor]], className])

  return (
    <Spacer {...otherProps} className={classNames}>
      {children}
      {footerButtons != null && (
        <div className={styles.footer}>{footerButtons}</div>
      )}
    </Spacer>
  )
}
